import React, { Component, useEffect, useState } from "react";
import image from "../assets/greenpatch.png";
import { Link } from "react-router-dom";

import * as ROUTES from "../constants/routes";
import { SignInLink } from "./SignIn";
import { connect } from "react-redux";
import {
  createUser,
  emailChanged,
  phoneNumberChanged,
  googleLogin,
  passwordChanged,
  cancelGoogleSignup,
  completeGoogleSignup,
  redirectIfShipshapAccountExists,
} from "./actions/AuthActions";

import { ReactComponent as BoxLogo } from "../assets/box-in-logo-green.svg";
import { ReactComponent as BoxLogoWhite } from "../assets/box-in-logo.svg";
import { ReactComponent as GlobeVisual } from "../assets/auth-globe.svg";
import { ReactComponent as GoogleLogo } from "../assets/google-logo.svg";
import { Spinner } from "react-bootstrap";
import history from "../History";
import {
  FiAlertCircle,
  FiEye,
  FiEyeOff,
  FiCheck,
  FiInfo,
} from "react-icons/fi";
import PhoneInput from "react-phone-input-2";
import { isValidPhoneNumber } from "./Home/common/helpers";
import { COMPLETE_GOOGLE_SIGNUP_PARAM } from "./actions/ActionHelpers";

const isCompleteGoogleSignup = () =>
  new URLSearchParams(window.location.search).get(
    COMPLETE_GOOGLE_SIGNUP_PARAM,
  ) === "1";

const SignUpPage = (props) => {
  const [error, setError] = useState("");
  const [completeSignup, setCompleteSignup] = useState(isCompleteGoogleSignup);
  const [showGoogleModal, setShowGoogleModal] = useState(
    isCompleteGoogleSignup,
  );

  useEffect(() => {
    const syncGoogleSignup = () => {
      const completing = isCompleteGoogleSignup();
      setCompleteSignup(completing);
      if (completing) {
        setShowGoogleModal(true);
      }
    };
    syncGoogleSignup();
    const unlisten = history.listen(() => {
      syncGoogleSignup();
    });
    const unsubscribe = redirectIfShipshapAccountExists();
    return () => {
      unlisten();
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  return (
    <div className="auth signup d-flex flex-row">
      <div
        className={
          "col-12 col-lg-5 d-none d-lg-flex flex-column align-items-center"
        }
      >
        <a
          href={"https://shipshap.com"}
          className="header d-flex flex-row align-items-center"
        >
          <div>
            <BoxLogo />
          </div>
          <h2 className="mb-0">ShipShap</h2>
        </a>

        <div className={"intro d-flex flex-column align-items-center"}>
          <div className={"visual d-flex flex-row align-items-center"}>
            <GlobeVisual />
          </div>

          <div className={"text-center"}>
            <p className={"info"}>
              We connect you with the best shipping rates and streamline the
              order fulfillment process for you, from importing your orders, to
              printing a label, to tracking: all from the convenience of your
              device. Shipping from Africa and beyond has never been easier
            </p>
          </div>
        </div>
      </div>
      <div className="patch col-12 col-lg-7 m-auto d-flex flex-column align-items-center text-left justify-content-around">
        <a
          href={"https://shipshap.com"}
          className="header d-flex d-lg-none flex-row align-items-center"
        >
          <div>
            <BoxLogoWhite />
          </div>
          <h2 className="mb-0">ShipShap</h2>
        </a>
        <div className="box container  col-10 col-lg-6 d-flex flex-column justify-content-center align-items-start text-left">
          <h3 className="signlabel text-center ">Sign up</h3>
          {!error && props.error && props.error !== "" && (
            <div className={"error-block text-newline-wrap"}>
              <FiAlertCircle />
              <div className="m-0">
                <p className="text-danger m-0">{props.error}</p>
              </div>
            </div>
          )}
          {error && (
            <div className={"error-block text-newline-wrap"}>
              <FiAlertCircle />
              <div className="m-0">
                <p className="text-danger m-0">{error}</p>
              </div>
            </div>
          )}
          <SignUpForm showError={(error) => setError(error)} />

          <p className="divider">
            <span className="text">or</span>
          </p>
          <button
            className="googlesignin"
            onClick={() => {
              setCompleteSignup(false);
              setShowGoogleModal(true);
            }}
          >
            <GoogleLogo className={"mr-3"} />
            Sign up with Google
          </button>
          <div
            className={
              "switchForm d-flex flex-row justify-content-center align-items-center"
            }
          >
            <p className={"mb-0 "}>
              Already have an account?
              <Link to={ROUTES.SIGN_IN} className={"ml-3"}>
                Sign In
              </Link>
            </p>
          </div>
        </div>
      </div>
      {(showGoogleModal || completeSignup) && (
        <SignInWithGoogleButton
          completeSignup={completeSignup}
          closeModal={() => setShowGoogleModal(false)}
        />
      )}
    </div>
  );
};

const INITIAL_STATE = {
  passwordTwo: "",
  error: "",
  showPassword: false,
  accepted: false,
  phoneError: false,
};

const getUtmMetadata = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.size === 0) {
    return null;
  }
  const metadata = {};
  params.forEach((value, key) => {
    if (key === COMPLETE_GOOGLE_SIGNUP_PARAM) return;
    metadata[key] = value;
  });
  return Object.keys(metadata).length > 0 ? metadata : null;
};

class SignUpFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    event.preventDefault();

    const { email, password } = this.props;

    if (!isValidPhoneNumber(this.props.phone_number)) {
      this.props.showError("Invalid phone number");
      return;
    }

    if (password !== this.state.passwordTwo) {
      this.props.showError("Passwords do not match");
      return;
    }

    this.props.createUser({
      email,
      password: password,
      phoneNumber: this.props.phone_number,
      utmMetadata: getUtmMetadata(),
    });
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value, error: "" });
    this.props.showError("");
  };

  isInvalidPhoneNumber = (phoneNumber) => {
    return !isValidPhoneNumber(phoneNumber);
  };

  render() {
    const { email, password, error } = this.props;
    const { passwordTwo } = this.state;

    const isInvalidPhoneNumber = !isValidPhoneNumber(this.props.phone_number);
    const isInvalid =
      password === "" ||
      passwordTwo === "" ||
      email === "" ||
      isInvalidPhoneNumber ||
      !this.state.accepted;

    return (
      <form onSubmit={this.onSubmit}>
        <label htmlFor="email" className={"col-12 p-0 d-flex flex-column"}>
          Email
        </label>
        <input
          type="email"
          name="email"
          value={email}
          onChange={(event) => this.props.emailChanged(event.target.value)}
          placeholder="user@gmail.com"
        />
        <label className={`col-12 p-0 d-flex flex-column `} htmlFor="phone">
          Phone Number
        </label>
        <div
          className={`phone-number-field ${isInvalidPhoneNumber ? "error" : ""}`}
        >
          <PhoneInput
            country={"ke"}
            name="phone"
            value={this.props.phone_number}
            onChange={(phone) => {
              this.props.phoneNumberChanged(phone);
            }}
            placeholder={"Enter your phone number"}
            enableTerritories
          />
        </div>
        <label htmlFor="password" className={"col-12 p-0 d-flex flex-column"}>
          Password
        </label>
        <div className={"password-field"}>
          <input
            type={this.state.showPassword ? "text" : "password"}
            name="passwordOne"
            value={password}
            onChange={(event) => this.props.passwordChanged(event.target.value)}
            placeholder="Password"
          />
          <div
            className={"show-pass-button"}
            onClick={() => {
              this.setState({ showPassword: !this.state.showPassword });
            }}
          >
            {this.state.showPassword ? <FiEye /> : <FiEyeOff />}
          </div>
        </div>
        <label
          htmlFor="passwordTwo"
          className={"col-12 p-0 d-flex flex-column"}
        >
          Confirm Password
        </label>
        <div className={"password-field"}>
          <input
            type={this.state.showPassword ? "text" : "password"}
            name="passwordTwo"
            value={passwordTwo}
            onChange={this.onChange}
            placeholder="Retype your password"
          />
        </div>

        <div
          className={`checkbox d-flex flex-row justify-content-start ${this.state.accepted ? "active" : ""}`}
          onClick={() => this.setState({ accepted: !this.state.accepted })}
        >
          <div className={`check`}>
            <FiCheck />
          </div>
          <p className={"m-0"}>
            By creating an account, you agree to our &nbsp;{" "}
            <Link to={ROUTES.TERMS}>Terms and Conditions</Link>
          </p>
        </div>

        <button className="btn1" disabled={isInvalid} type="submit">
          {this.props.loading ? (
            <Spinner animation="border" role="status" className={"mt-0"} />
          ) : (
            "Create Account"
          )}
        </button>
      </form>
    );
  }
}

const SignUpButton = () => (
  <Link to={ROUTES.SIGN_UP}>
    <button className="btn2">Create Account</button>
  </Link>
);

const mapStateToProps = ({ auth }) => ({
  email: auth.email,
  phone_number: auth.phone_number,
  password: auth.password,
  error: auth.error,
  loading: auth.loading,
});
// const SignUpForm = compose(withRouter, withFirebase)(SignUpFormBase);
const SignUpForm = connect(mapStateToProps, {
  createUser,
  emailChanged,
  passwordChanged,
  phoneNumberChanged,
})(SignUpFormBase);

const SignInWithGoogleModal = (props) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");

  const handleClose = () => {
    if (props.completeSignup) {
      props.cancelGoogleSignup();
    }
    props.closeModal();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isValidPhoneNumber(phoneNumber)) {
      setError("Please enter a valid phone number");
      return;
    }
    setError("");
    const utmMetadata = getUtmMetadata();
    if (props.completeSignup) {
      props.completeGoogleSignup(phoneNumber, utmMetadata);
      return;
    }
    props.googleLogin(phoneNumber, utmMetadata);
  };

  return (
    <div className="modal">
      <div className="backdrop" onClick={handleClose}></div>
      <div className="modal-content google-signup-modal lineitem-details">
        <div className={"info-block text-newline-wrap"}>
          <FiInfo />
          <div className="m-0">
            <p className="m-0">
              Enter your phone number to sign up with Google
            </p>
          </div>
        </div>
        {props.error && (
          <div className={"error-block text-newline-wrap"}>
            <FiAlertCircle />
            <div className="m-0">
              <p className="text-danger m-0">{props.error}</p>
            </div>
          </div>
        )}
        <label className={`col-12 p-0 d-flex flex-column `} htmlFor="phone">
          Phone Number
        </label>
        <div className={`phone-number-field ${error ? "error" : ""}`}>
          <PhoneInput
            country={"ke"}
            name="phone"
            value={phoneNumber}
            onChange={(phone) => {
              setError("");
              setPhoneNumber(phone);
            }}
            placeholder={"Enter your phone number"}
            enableTerritories
          />
        </div>
        {error && <p className="error">{error}</p>}
        <button
          className="googlesignin"
          disabled={props.loading}
          onClick={(e) => {
            handleSubmit(e);
          }}
        >
          {props.loading ? (
            <Spinner animation="border" role="status" className={"mt-0"} />
          ) : (
            <>
              {props.completeSignup ? null : <GoogleLogo className={"mr-3"} />}
              {props.completeSignup ? "Continue" : "Sign up with Google"}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

const mapSignInWithGoogleModalStateToProps = ({ auth }) => ({
  error: auth.error,
  loading: auth.loading,
});

const SignInWithGoogleButton = connect(mapSignInWithGoogleModalStateToProps, {
  googleLogin,
  completeGoogleSignup,
  cancelGoogleSignup,
})(SignInWithGoogleModal);

const mapSignInPageStateToProps = ({ auth }) => ({
  error: auth.error,
});
export default connect(mapSignInPageStateToProps, null)(SignUpPage);

export { SignUpButton, SignUpForm, SignInWithGoogleButton };
